/**
 * External dependencies
 */
import { Reducer } from 'redux';
import produce from 'immer';

/**
 * Internal dependencies
 */
import Attachment from '@naruto/bgdcms//src/reducers/stores/attachment';
import ATTACHMENT_ACTION from '@naruto/bgdcms//src/reducers/cores/attachment/events';
import { CreateAttachmentReducerParams, AttachmentActionTypes } from './types';

export function createAttachmentReducer(
  params: CreateAttachmentReducerParams
): Reducer<Attachment, AttachmentActionTypes> {
  return (state = params.initialState, action: AttachmentActionTypes): Attachment =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case ATTACHMENT_ACTION.SET_ATTACHMENT_INITIALIZE:
          draft.initialize();
          break;
        case ATTACHMENT_ACTION.SET_ATTACHMENT_LIST:
          draft.updateAttachmentList(action.list);
          break;
        case ATTACHMENT_ACTION.CLEAR_ATTACHMENT_LIST:
          draft.clearAttachmentList();
          break;
        default:
          break;
      }
    });
}
